import React from "react";
import certificate from "../../assets/images/certificate.jpeg";

const Certificate = () => {
  return (
    <>
      <section className="as_breadcrum_wrapper">
        <div className="container animate__animated animate__fadeInUp animate__repeat-1 animate__delay-1s ">
          <div className="row">
            <div
              data-aos="fade-up"
              data-aos-delay="200"
              className="col-lg-12 text-center"
            >
              <h1 className="as_heading as_heading_center">Certificate</h1>
            </div>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="200"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <img
            src={certificate}
            alt="certificate"
            style={{ marginTop: "35px" }}
          />
        </div>
      </section>
    </>
  );
};

export default Certificate;
